import axios from "axios";

import config from "./config";

export default class SolicitacaoService {

  static async sendMosia(carteira, nome, telefone1, telefone2, local, email, chaveUnica, tipaut) {
    let contrato = carteira.slice(0, -3).trim();

    const tipoGuiaLabels = {
      '2': 'Consultas | Exames | Terapias',
      '1': 'Cirurgias | Internações | Medicamentos'
    };

    const bodyData = {
      "idTipoOcorrencia": "67",
      "idAssunto": 914,
      "rascunho": 0,
      "solicitante": {
        "chaveUnica": chaveUnica,
        "nome": nome,
        "email": email,
        "telefone": telefone1
      },
      "beneficiario": {
        "chaveUnica": chaveUnica,
        "nome": nome,
        "email": email,
        "telefone": telefone1
      },
      "numeroContrato": contrato, 
      "anotacao": "", 
      "formularios": [
        {
          "idForm": "6324633dd5bf27afeb8242d2",
          "formData": [
            {
              "nome": nome,
              "Matricula": carteira,
              "telefone-celular": telefone1,
              "e-mail": email,
              "local": local,
              "selecione-o-tipo-de-guia": { label: tipoGuiaLabels[tipaut], value: tipaut },
              "imagem-da-guia": []
            }
          ]
        }
      ]
    };
  
  
    let response = "";
    try {
      response = await axios.post(config.API_URL_MOSIA, bodyData, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": config.AUT_MOSIA
        }
      });
    } catch (err) {
      return {status: false, error: err};
    }
  
    return response.data;
  }

  static async sendAnexo(protocolo, fileUrl, chaveUnica, linkUrl) {
    let bodyData
    if(!linkUrl){
      bodyData = {
        publica: true,
        chaveUnicaSolicitante: chaveUnica,
        arquivos: [
            {
                base64: fileUrl
            }
        ]
      };

    }else{
      bodyData = {
          publica: true,
          chaveUnicaSolicitante: chaveUnica,
          arquivos: [
              {
                  url: linkUrl  //upload s3
              }
          ]
      };

    }
    try {
        const response = await axios.post(`https://api.mosiaomnichannel.com.br/clientes/ocorrencias/${protocolo}/anotacao`, bodyData, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": config.AUT_MOSIA
            }
        });

        // Envia também como anotação de mensagem
        if (linkUrl) {
            // Quando temos linkUrl, envia a URL como mensagem
            await this.sendAnotacaoLink(protocolo, chaveUnica, linkUrl);
        } else {
            // Quando não temos linkUrl, envia o base64 como mensagem
            await this.sendAnotacaoLink(protocolo, chaveUnica, fileUrl);
        }

        return response.data;
    } catch (err) {
        return { status: false, error: err };
    }
  }

  /**
   * Envia o link da imagem ou base64 como anotação de mensagem na ocorrência
   */
  static async sendAnotacaoLink(protocolo, chaveUnica, linkUrl) {
    const bodyData = {
      publica: false,
      chaveUnicaSolicitante: chaveUnica,
      mensagem: linkUrl
    };
    try {
        const response = await axios.post(`https://api.mosiaomnichannel.com.br/clientes/ocorrencias/${protocolo}/anotacao`, bodyData, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": config.AUT_MOSIA
            }
        });
        return response.data;
    } catch (err) {
        console.error('Erro ao enviar anotação do link:', err);
        return { status: false, error: err };
    }
  }

  static async senMinio(file,matriculauser) {

    const formData = new FormData();
    formData.append('file', file);
    try {
      const response = await axios.post(config.API_CLIENTE_DIGITAL +'/sendMinio?matricula='+ matriculauser, formData, {
          headers: {
              'client_id_secret': 'Basic MTQ2YzMxYzgtY2NjMC0zYTM4LTk4MWYtMzY0MmI3YjVkZWI0OmViNzgwMTQyLTM5MDAtM2Y3My05ZmE5LTNhMjM3Y2Q0ZWM1ZQ==',
              'Content-Type': 'multipart/form-data; boundary=<calculated when request is sent>',
          }
      });

      if (response.data && response.data.caminho) {
          const fullUrl = `${config.API_CLIENTE_DIGITAL}/getDocIo?fileName=${response.data.caminho}`;
          return { status: true, fileUrl: fullUrl };
      } else {
          return { status: false, message: 'Erro ao gerar link do arquivo' };
      }
    } catch (err) {
      console.error('Erro ao gerar link do documento:', err);
      return { status: false, error: err };
    }
  }

  static async deletaArquivoNoServidor(fileName, matriculaUser) {

    const bodyData = {
      fileName: fileName,
      matricula: matriculaUser
    };

    try {
      const response = await axios.delete(config.API_CLIENTE_DIGITAL +'/deleteDocumento', {
          headers: {
              'client_id_secret': 'Basic MTQ2YzMxYzgtY2NjMC0zYTM4LTk4MWYtMzY0MmI3YjVkZWI0OmViNzgwMTQyLTM5MDAtM2Y3My05ZmE5LTNhMjM3Y2Q0ZWM1ZQ==',
              'Content-Type': 'application/json'
          },
          data: bodyData
      });

      if (response.status === 200) {
          
          return { status: true };
      } else {
          return { status: false, message: 'Erro ao deletar arquivo no servidor.' };
      }
    } catch (err) {
        console.error('Erro ao deletar arquivo no servidor:', err);
        return { status: false, error: err };
    }
  }
}
